export const getNoun = (count: number, one: string, two: string, five: string) => {
  let n = Math.abs(count)
  n %= 100
  if (n >= 11 && n <= 19) return five
  n %= 10
  if (n === 1) return one
  if (n >= 2 && n <= 4) return two
  return five
}
